// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:992px){.cr56xLe2E8tkdlbm1MjNHw\\=\\=:before{background:rgba(0,0,0,.667);bottom:0;content:\"\";left:0;position:fixed;right:0;top:0;z-index:1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": "cr56xLe2E8tkdlbm1MjNHw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
